"use strict";
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
export const copyToClipboard = (value, onError) => __async(void 0, null, function* () {
  if (navigator == null ? void 0 : navigator.clipboard) {
    try {
      yield navigator.clipboard.writeText(value);
    } catch (e) {
      fallback(value, onError);
    }
  } else {
    fallback(value, onError);
  }
});
const fallback = (value, onError) => {
  try {
    const copyElement = document.createElement("textarea");
    copyElement.value = value;
    document.body.appendChild(copyElement);
    copyElement.select();
    document.execCommand("copy");
    copyElement.remove();
  } catch (error) {
    if (onError)
      onError();
  }
};
